import { Link } from 'react-router-dom';
import { useApi } from '../api/context';
import { useAsync } from '../api/useAsync';
import { Page, PageHeader, Card, Loading, ErrorState, Empty } from '../components/common';
import { AddCustomer } from '../components/AddCustomer';
import {
  makeStyles, tokens, Text, Badge,
  Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  muted: { color: tokens.colorNeutralForeground3, fontSize: tokens.fontSizeBase200 },
  link: { color: tokens.colorBrandForeground1, textDecorationLine: 'none' },
});

export function Tenants() {
  const styles = useStyles();
  const api = useApi();
  const tenants = useAsync(() => api.getTenants(), []);

  if (tenants.loading) return <Loading />;
  if (tenants.error) return <ErrorState error={tenants.error} />;

  const rows = tenants.data ?? [];

  return (
    <Page>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '16px' }}>
        <PageHeader
          title="Customers"
          description="Tenants registered on this stamp. Other regions are not visible from here."
        />
        <AddCustomer onAdded={tenants.reload} />
      </div>

      <Card>
        {rows.length === 0 ? (
          <Empty>
            No customers registered on this stamp yet. Add one to run an assessment
            against it.
          </Empty>
        ) : (
          <Table aria-label="Customers" size="medium">
            <TableHeader>
              <TableRow>
                <TableHeaderCell>Customer</TableHeaderCell>
                <TableHeaderCell>Consent</TableHeaderCell>
                <TableHeaderCell>Frameworks</TableHeaderCell>
                <TableHeaderCell>Region</TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((t) => (
                <TableRow key={t.tenantId}>
                  <TableCell>
                    <Link to={`/tenants/${t.tenantId}`} className={styles.link}>
                      <Text weight="semibold">{t.displayName}</Text>
                    </Link>
                    <div className={styles.muted}>{t.primaryDomain ?? t.entraTenantId}</div>
                  </TableCell>
                  <TableCell>
                    {/* Without consent nothing can be collected, so this is the
                        first thing worth seeing about a customer. */}
                    {t.consentGranted ? (
                      <Badge appearance="tint" color="success">Granted</Badge>
                    ) : (
                      <Badge appearance="tint" color="danger">Not granted</Badge>
                    )}
                  </TableCell>
                  <TableCell>
                    {t.frameworks.length === 0 ? (
                      <span className={styles.muted}>Fallback only</span>
                    ) : (
                      <span className={styles.muted}>
                        {t.frameworks.map((f) => f.name).join(', ')}
                      </span>
                    )}
                  </TableCell>
                  <TableCell>
                    <span className={styles.muted}>{t.homeRegion}</span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </Page>
  );
}
